const HIGHLIGHTED = [
  "Côte d'Ivoire", "Sénégal", "Mali", "Burkina Faso", "Bénin",
  "Togo", "Guinée", "Cameroun", "Niger", "Rép. Dém. du Congo",
];

const dots = [
  { x: 130, y: 215 }, { x: 110, y: 200 }, { x: 145, y: 190 },
  { x: 155, y: 215 }, { x: 170, y: 235 }, { x: 160, y: 240 },
  { x: 115, y: 225 }, { x: 235, y: 250 }, { x: 195, y: 195 },
  { x: 260, y: 310 },
];

export function AfricaMap() {
  return (
    <div className="relative aspect-[4/5] w-full max-w-md mx-auto" data-testid="africa-map">
      <svg viewBox="0 0 400 500" className="w-full h-full drop-shadow-xl">
        <defs>
          <linearGradient id="africaGrad" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="oklch(0.28 0.02 40)" />
            <stop offset="100%" stopColor="oklch(0.6 0.19 42)" />
          </linearGradient>
        </defs>
        <path
          fill="url(#africaGrad)"
          stroke="oklch(0.72 0.19 45)"
          strokeWidth="1.5"
          d="M180 30 C 220 25 260 35 285 60 C 305 80 310 105 320 130 C 335 165 355 190 350 225 C 345 260 325 285 320 320 C 315 360 290 395 260 430 C 240 455 215 475 195 478 C 175 480 160 460 150 435 C 140 410 130 385 115 365 C 95 340 75 315 70 285 C 65 255 75 225 85 195 C 95 165 105 135 120 110 C 135 80 155 50 180 30 Z"
        />
        {dots.map((p, i) => (
          <g key={i}>
            <circle cx={p.x} cy={p.y} r="11" fill="oklch(0.72 0.19 45)" opacity="0.25">
              <animate attributeName="r" values="8;16;8" dur="2.6s" repeatCount="indefinite" />
              <animate attributeName="opacity" values="0.3;0;0.3" dur="2.6s" repeatCount="indefinite" />
            </circle>
            <circle cx={p.x} cy={p.y} r="5" fill="oklch(0.72 0.19 45)" />
          </g>
        ))}
      </svg>
      <div className="mt-6 flex flex-wrap gap-2 justify-center">
        {HIGHLIGHTED.map((c) => (
          <span
            key={c}
            className="text-xs font-medium px-3 py-1.5 rounded-full bg-royal/15 text-royal border border-royal/30"
          >
            {c}
          </span>
        ))}
      </div>
    </div>
  );
}
